var map = {
	"./favicon.ico": 11,
	"./favicon_114.png": 12,
	"./favicon_120.png": 13,
	"./favicon_144.png": 14,
	"./favicon_152.png": 15,
	"./favicon_57.png": 16,
	"./favicon_60.png": 17,
	"./favicon_72.png": 18,
	"./favicon_76.png": 19,
	"./favicon_fb.png": 20,
	"./windows_large.png": 21,
	"./windows_square.png": 22,
	"./windows_tiny.png": 23,
	"./windows_wide.png": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;